import React, { useRef } from "react";
import styled from "styled-components";
import { rem } from "polished";

import mq from "../../../helpers/media-queries";
import Sidebar from "./Sidebar";
import sections from "./sections.json";
import { useHistory, useLocation } from "react-router-dom";
import ArrowLeft from "../../../assets/img/arrow-left.png";

import {
	ConfigurationContext,
	ConfigurationProvider,
} from "./ConfigurationContext";
import { SketchfabProvider } from "../../Sketchfab/SketchfabContext";
import RenderContainer from "../../RenderContainer/RenderContainer";
import RenderIframe from "./RenderIframe";
import modelNodes from "./modelNodes";
import { ReactComponent as RoyalTubsLogo } from "../../../assets/img/royaltubs-logo.svg";
import { useCurrentContext } from "../../../hooks/useCurrentContext";

const Container = styled.div`
	${mq("sm", "min")} {
		height: 100%;
		display: flex;
	}
`;

const LogoContainer = styled.div`
	display: none;

	${mq("desktop", "min")} {
		position: absolute;
		width: 150px;
		left: 50%;
		transform: translateX(-50%);
		top: 20px;
		display: block;
	}

	svg {
		width: 100%;
	}
`;

const Headline = styled.h1`
	display: none;

	${mq("sm", "min")} {
		font-family: "Tiempos Headline", sans-serif;
		position: absolute;
		padding: 24px 0;
		font-size: 30px;
		line-height: 1.3;
		color: #5b5a50;
		display: block;
	}
`;

const Back = styled.a`
	font-weight: 400;
	font-size: 12px;
	font-family: sans-serif;
	color: #5a4a44;
	text-decoration: none;
	position: absolute;
	top: 27px;
	left: 42px;
	display: flex;
	cursor: pointer;

	img {
		height: 12px;
		margin-right: ${rem(8)};
	}
`;

const DeluxePage = () => {
	const viewerRef = useRef(null);
	const { addCurrentContext } = useCurrentContext();
	addCurrentContext(ConfigurationContext);
	const { pathname } = useLocation();
	const [, path] = pathname.split("/");
	const backToLink = `/${path}`;
	const history = useHistory();

	return (
		<ConfigurationProvider>
			<SketchfabProvider
				modelUID="2c0d180ee74949d08e9e8662ec9748db"
				initialNodes={modelNodes.initial}
				viewerRef={viewerRef}
			>
				<Container>
					<RenderContainer relative={true}>
						<LogoContainer>
							<a href="/">
								<RoyalTubsLogo />
							</a>
						</LogoContainer>
						<RenderIframe viewerRef={viewerRef} />
					</RenderContainer>
					<Sidebar sections={sections} />
				</Container>
			</SketchfabProvider>
		</ConfigurationProvider>
	);
};

export default DeluxePage;
